import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=549fbb4a&scoped=true&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"
import style0 from "./_UserAvatar.scss?vue&type=style&index=0&id=549fbb4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549fbb4a",
  null
  
)

export default component.exports